import styled from "styled-components";

export const Wrapper = styled.div`
  .modal-input {
    border: 1px solid #566787;
    font-size: 15px;
    height: 41px;
    margin: 0px;
    ::placeholder {
      color: #566787;
      font-size: 15px;
    }
  }
  .modal-date-input {
    border: 1px solid #566787;
    font-size: 15px;
    height: 41px;
    width: 100%;
    margin: 0px;
    ::placeholder {
      color: #566787;
      font-size: 15px;
    }
  }
  .ant-modal-body {
    padding-top: 11px !important;
  }
  .modal-label {
    color: #566787;
    /* padding-bottom: 4px; */
    padding-left: 2px;
  }
  .add-status-modal-row {
    margin-top: -10px;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
  .ant-select-selector {
    height: 41px !important;
    border-radius: 3px !important;
    border: 1px solid #566787 !important;
    font-size: 15px !important;
  }
  .ant-select-selection-placeholder {
    font-size: 15px !important;
    margin-top: 5px;
    color: #566787 !important;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
    .ant-select-selector
    input {
    margin-top: 5px !important;
  }
  .ant-select-selection-item {
    margin-top: 5px !important;
  }
`;
